import EmptyPage from './empty-pages'

export default EmptyPage
